module.exports = __webpack_public_path__ + "static/media/7.19e5db36.JPG";